export default __webpack_public_path__ + "static/media/solid.e039e767.svg";